import type { StepperProps } from '@latitude/stepper';
import { Stepper } from '@latitude/stepper';
import { useCallback, useEffect, useState } from 'react';

export const InternalFormStepper = ({
  value,
  minValue,
  maxValue,
  onChange,
  ...stepperProps
}: StepperProps) => {
  const [stepperValue, setStepperValue] = useState<number | undefined>(value);

  // Sync internal state with external value prop
  useEffect(() => {
    setStepperValue(value);
  }, [value]);

  // Handle stepper value changes (from user interaction only)
  const handleStepperChange = useCallback(
    (newValue: number) => {
      setStepperValue(newValue);
      onChange?.(newValue);
    },
    [onChange],
  );

  return (
    <Stepper
      {...stepperProps}
      value={stepperValue}
      minValue={minValue}
      maxValue={maxValue}
      onChange={handleStepperChange}
    />
  );
};
